<template>
  <div class="dashboard-container">
    <div class="card-grid">
      <a-card class="stats-card" title="累计订单金额">
        <template #extra>
          <a-tag color="blue">订单</a-tag>
        </template>
        <span class="main-value">{{ home.product_order_total }}</span>
        <div class="sub-info">
          <span>总订单数</span>
          <span>
            {{ home.product_order_total_count }}
            <AppstoreOutlined class="icon" />
          </span>
        </div>
      </a-card>

      <a-card class="stats-card" title="系统会员">
        <template #extra>
          <a-tag color="red">会员</a-tag>
        </template>
        <span class="main-value">{{ home.user_total }}</span>
        <div class="sub-info">
          <span>今日新增会员数</span>
          <span>
            {{ home.now_add_user_count }}
            <UserOutlined class="icon" />
          </span>
        </div>
      </a-card>

      <a-card class="stats-card" title="在线储值笔数">
        <template #extra>
          <a-tag color="green">数量</a-tag>
        </template>
        <span class="main-value">{{ home.recharge_activity_order_count }}</span>
        <div class="sub-info">
          <span>今日充值笔数</span>
          <span>
            {{ home.recharge_activity_order_now_count }}
            <PayCircleOutlined class="icon" />
          </span>
        </div>
      </a-card>

      <a-card class="stats-card" title="出售中的商品">
        <template #extra>
          <a-tag color="yellow">商品</a-tag>
        </template>
        <span class="main-value">{{ home.product_active_count }}</span>
        <div class="sub-info">
          <span>仓库中的商品</span>
          <span>
            {{ home.product_stock_count }}
            <ProjectOutlined class="icon" />
          </span>
        </div>
      </a-card>
    </div>

    <div class="card-grid secondary-grid">
      <a-card class="shortcut-card" title="快捷方式">
        <div class="shortcut-container">
          <div class="shortcut-column">
            <div class="shortcut-item" @click="handleRouter('/admin/user')">
              <UsergroupAddOutlined class="shortcut-icon" />
              <span>所有会员</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/order/paid')">
              <AccountBookOutlined class="shortcut-icon" />
              <span>所有订单</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/order/pending')">
              <CarOutlined class="shortcut-icon" />
              <span>待发货订单</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/product/active')">
              <BankOutlined class="shortcut-icon" />
              <span>所有商品</span>
            </div>
          </div>
          <div class="shortcut-column">
            <div class="shortcut-item" @click="handleRouter('/journal')">
              <CloudOutlined class="shortcut-icon" />
              <span>日记存稿</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/user/recharge')">
              <ContactsOutlined class="shortcut-icon" />
              <span>在线储值记录</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/user/reply')">
              <DatabaseOutlined class="shortcut-icon" />
              <span>回信管理</span>
            </div>
            <div class="shortcut-item" @click="handleRouter('/system')">
              <LaptopOutlined class="shortcut-icon" />
              <span>系统设置</span>
            </div>
          </div>
        </div>
      </a-card>

      <a-card class="stats-card secondary" title="快捷方式">
        <div class="stats-item">
          <span>今日订单</span>
          <span>{{ home.product_order_now_count }}</span>
        </div>
        <div class="stats-item">
          <span>今日成交额</span>
          <span>{{ home.product_order_now_total }}</span>
        </div>
        <div class="stats-item">
          <span>近一个月的订单</span>
          <span>{{ home.product_order_month_count }}</span>
        </div>
        <div class="stats-item">
          <span>近一个月成交额</span>
          <span>{{ home.product_order_month_total }}</span>
        </div>
      </a-card>

      <a-card class="stats-card secondary" title="代办事项">
        <div class="stats-item">
          <span>待审核订单</span>
          <span>{{ home.product_order_pending_count }}</span>
        </div>
        <div class="stats-item">
          <span>已支付订单</span>
          <span>{{ home.product_order_paid_count }}</span>
        </div>
        <div class="stats-item">
          <span>已制作订单</span>
          <span>{{ home.product_order_processed_count }}</span>
        </div>
        <div class="stats-item">
          <span>已寄出订单</span>
          <span>{{ home.product_order_shipped_count }}</span>
        </div>
      </a-card>
    </div>

    <div class="table-container">
      <a-table
        :columns="columns"
        :data-source="home.now_add_user"
        :pagination="false"
        bordered
        class="custom-table"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'is_delete'">
            <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
            <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
          </template>
          <template v-else-if="column.dataIndex === 'status'">
            <a-tag v-if="record.status === 1" color="green">可用</a-tag>
            <a-tag v-if="record.status === 2" color="red">禁用</a-tag>
          </template>
          <template v-else-if="column.dataIndex === 'avatar'">
            <div v-if="record.avatar === ''" style="font-size: 32px">
              <UserOutlined />
            </div>
            <a-image
              v-else
              :src="ToImage(record.avatar)"
              style="height: 48px; width: auto"
            />
          </template>
          <template v-else-if="column.dataIndex === 'origin'">
            <span v-if="record.status === 1">微信小程序</span>
          </template>
          <template v-else-if="column.dataIndex === 'leave_time'">
            <span>{{
              dayjs(record.leave_time).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
          <template v-else-if="column.dataIndex === 'come_time'">
            <span>{{
              dayjs(record.come_time).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
          <template v-else-if="column.dataIndex === 'create_at'">
            <span>{{
              dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
          <template v-else-if="column.dataIndex === 'update_at'">
            <span>{{
              dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { SystemService } from "@/api/services/SystemService";
import { onMounted, reactive } from "vue";
import { Home } from "@/api/models/system/Home";
import {
  AppstoreOutlined,
  UserOutlined,
  PayCircleOutlined,
  ProjectOutlined,
  UsergroupAddOutlined,
  AccountBookOutlined,
  CarOutlined,
  BankOutlined,
  CloudOutlined,
  ContactsOutlined,
  DatabaseOutlined,
  LaptopOutlined,
} from "@ant-design/icons-vue";
import { ColumnType } from "ant-design-vue/lib/table";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { useRouter } from "vue-router";

// @ts-ignore
const home = reactive<Home>({});

const router = useRouter();

const handleHome = async () => {
  const res = await SystemService.Home();
  if (res.code === 0) {
    Object.assign(home, res.data);
  }
};

onMounted(() => {
  handleHome();
});

const handleRouter = (path: string) => {
  router.push({ path: path });
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "OpenId",
    dataIndex: "open_id",
    align: "center",
  },
  {
    title: "头像",
    dataIndex: "avatar",
    align: "center",
  },
  {
    title: "用户名",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "来源",
    dataIndex: "origin",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
];
</script>

<style scoped>
.dashboard-container {
  padding: 24px;
  background: #f0f2f5;
  min-height: 100%;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.secondary-grid {
  grid-template-columns: repeat(3, 1fr);
}

.stats-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.stats-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.main-value {
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
  display: block;
  margin-bottom: 12px;
}

.sub-info {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

.sub-info .icon {
  color: #1890ff;
  margin-left: 4px;
}

.shortcut-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.shortcut-container {
  display: flex;
  gap: 24px;
}

.shortcut-column {
  flex: 1;
}

.shortcut-item {
  padding: 12px;
  margin: 8px 0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.shortcut-item:hover {
  background: #f5f5f5;
  color: #1890ff;
}

.shortcut-icon {
  margin-right: 8px;
  font-size: 16px;
}

.stats-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
}

.stats-item:last-child {
  border-bottom: none;
}

.table-container {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.custom-table {
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 1200px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .secondary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr;
  }

  .secondary-grid {
    grid-template-columns: 1fr;
  }

  .shortcut-container {
    flex-direction: column;
  }
}
</style>
